export default "__VITE_ASSET__CExiCtY9__"